import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api/';

// 创建axios实例
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

// 添加请求拦截器来统一处理headers
apiClient.interceptors.request.use(
  (config) => {
    // 可以在这里添加通用的headers
    // 例如: config.headers['Authorization'] = 'Bearer ' + token;
    // 例如: config.headers['Content-Type'] = 'application/json';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 添加响应拦截器来统一处理响应
apiClient.interceptors.response.use(
  (response) => {
    // 输出API调用结果（仅在这里输出一次）
    console.log('API Response:', response.config.method?.toUpperCase(), response.config.url, response.status, response.data);
    return response;
  },
  (error) => {
    console.error('API Error:', error.response || error.message);
    return Promise.reject(error);
  }
);

/**
 * Fetch league standings for a specific country
 * @param {number} countryId - The ID of the country
 * @returns {Promise<any>} The league standings data
 */
export async function fetchLeagueStandings(countryId) {
  const response = await apiClient.get(`league-standings/?country=${countryId}`);
  return response.data.results || response.data;
}

/**
 * Fetch all countries
 * @returns {Promise<any>} The countries data
 */
export async function fetchCountries() {
  const response = await apiClient.get('countries/');
  return response.data.results || response.data;
}

/**
 * Fetch teams for a specific country
 * @param {number} countryId - The ID of the country
 * @returns {Promise<any>} The teams data
 */
export async function fetchTeams(countryId) {
  const response = await apiClient.get(`teams/?country=${countryId}`);
  return response.data.results || response.data;
}

/**
 * Fetch players with optional search term and team filter
 * @param {string} searchTerm - Optional search term
 * @param {number} teamId - Optional team ID to filter by
 * @returns {Promise<any>} The players data
 */
export async function fetchPlayers(searchTerm = '', teamId = null) {
  let endpoint = 'players/';
  
  if (searchTerm && teamId) {
    endpoint = `players/?search=${encodeURIComponent(searchTerm)}&team=${teamId}`;
  } else if (searchTerm) {
    endpoint = `players/?search=${encodeURIComponent(searchTerm)}`;
  } else if (teamId) {
    endpoint = `players/?team=${teamId}`;
  }
  
  const response = await apiClient.get(endpoint);
  return response.data.results || response.data;
}

/**
 * Fetch match results for a specific country
 * @param {number} countryId - The ID of the country
 * @returns {Promise<any>} The match results data
 */
export async function fetchMatchResults(countryId) {
  const response = await apiClient.get(`match-results/?country=${countryId}`);
  return response.data.results || response.data;
}

/**
 * Fetch player stats
 * @param {number} playerId - The ID of the player
 * @returns {Promise<any>} The player stats data
 */
export async function fetchPlayerStats(playerId) {
  const response = await apiClient.get(`player-stats/?player=${playerId}`);
  return response.data.results || response.data;
}

/**
 * Fetch match reviews
 * @returns {Promise<any>} The match reviews data
 */
export async function fetchMatchReviews() {
  const response = await apiClient.get('reviews/');
  return response.data.results || response.data;
}